import { requestCompletedAndSucceeded } from '../../../utils/request-succeeded';
import { createStore, select, withProps } from '@ngneat/elf';
import { joinRequestResult } from '@ngneat/elf-requests';
import { trackRequest } from '@tmx/core/elf-utils';
import { WeatherAlerts } from '@tmx/data-access';

type RequestKeys = 'fetch-weather-alerts' | 'save-weather-alerts';

interface WeatherProps {
  weatherAlerts: WeatherAlerts | null;
}

const weatherStore = createStore(
  { name: 'weather' },
  withProps<WeatherProps>({
    weatherAlerts: null,
  })
);

/** Snapshots */

export const weatherAlertsSnapshot = () => {
  const { weatherAlerts } = weatherStore.getValue();

  if (weatherAlerts === null) {
    throw new Error('weatherAlerts is not initialized');
  }

  return weatherAlerts;
};

/** Request Results Trackers */

export const trackWeatherRequests = <T>(keys: RequestKeys[]) =>
  trackRequest<T, RequestKeys>(keys);

export const joinWeatherRequests = <T>(keys: RequestKeys[]) =>
  joinRequestResult<T>(keys);

/** Exposed Variables and Observables */

export const weatherAlerts$ = weatherStore.pipe(
  select(({ weatherAlerts }) => weatherAlerts)
);

export const weatherAlertsInitialized$ = weatherStore.pipe(
  select(({ weatherAlerts }) => weatherAlerts),
  joinWeatherRequests(['fetch-weather-alerts']),
  requestCompletedAndSucceeded()
);

export const weatherAlertsSaved$ = weatherStore.pipe(
  select(({ weatherAlerts }) => weatherAlerts),
  joinWeatherRequests(['save-weather-alerts']),
  requestCompletedAndSucceeded()
);

/** Updater Functions */

export function updateweatherAlerts(weatherAlerts: WeatherAlerts) {
  weatherStore.update((state) => ({
    ...state,
    weatherAlerts,
  }));
}

export function resetWeatherStore() {
  weatherStore.reset();
}
